// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────
   Main container
───────────────────────────────────────────── */
.customer-table-v2___main-container {
  margin-top: 70px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 70px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1rem;
  padding-bottom: 2rem;
}

/* ─────────────────────────────────────────────
   Sticky header section
───────────────────────────────────────────── */
.customer-table-v2___header-section {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid rgba(255, 255, 255, 0.7);
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -2rem;
  margin-bottom: 1.5rem;
}

.customer-table-v2___header-inner {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  box-sizing: border-box;
}

/* ─────────────────────────────────────────────
   Title
───────────────────────────────────────────── */
.customer-table-v2___header-title {
  font-size: 1.5rem; /* 24px — matches text-2xl */
  font-weight: 700;
  color: #020617; /* slate-950 */
  margin: 0;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

/* ─────────────────────────────────────────────
   Right-side action group
───────────────────────────────────────────── */
.customer-table-v2___header-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem; /* gap-3 */
}

/* ─────────────────────────────────────────────
   Search input
───────────────────────────────────────────── */
.customer-table-v2___search-wrap {
  position: relative;
  display: none; /* hidden on mobile, shown on ≥ md */
}

@media (min-width: 768px) {
  .customer-table-v2___search-wrap {
    display: block;
  }
}

.customer-table-v2___search-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
  color: #94a3b8; /* slate-400 */
}

.customer-table-v2___search-input {
  height: 48px;
  width: 320px;
  border-radius: 1rem; /* rounded-2xl */
  border: 1px solid #e2e8f0; /* slate-200 */
  background-color: #ffffff;
  padding-left: 2.75rem; /* room for icon */
  padding-right: 1rem;
  font-size: 0.875rem; /* text-sm */
  color: #334155; /* slate-700 */
  outline: none;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
  box-sizing: border-box;
}

.customer-table-v2___search-input::placeholder {
  color: #94a3b8; /* slate-400 */
}

.customer-table-v2___search-input:focus {
  border-color: #2a71ff;
  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.1);
}

/* ─────────────────────────────────────────────
   Filter button
───────────────────────────────────────────── */
.customer-table-v2___filter-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  height: 48px;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 1rem;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  font-size: 0.875rem;
  font-weight: 500;
  color: #475569; /* slate-600 */
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;
  white-space: nowrap;
}

.customer-table-v2___filter-btn:hover {
  border-color: #cbd5e1; /* slate-300 */
  background-color: #f8fafc; /* slate-50 */
}

.customer-table-v2___chevron {
  display: flex;
  align-items: center;
  color: #94a3b8; /* slate-400 */
}

/* ─────────────────────────────────────────────
   Tabs row: tabs on the left, Loyalty Points
   button anchored to the opposite (right) end
───────────────────────────────────────────── */
.customer-table-v2___tabs-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-right: 1.5rem;
}

.customer-table-v2___tabs-row .tabs-container {
  flex: 1;
  min-width: 0;
  width: auto;
}

.customer-table-v2___loyalty-btn {
  flex-shrink: 0;
  height: 48px;
  padding-left: 1.6rem;
  padding-right: 1.6rem;
  border-radius: 1rem;
  border: none;
  background-color: #2a71ff;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 12px 24px rgba(42, 113, 255, 0.25);
  transition: background-color 0.15s ease, box-shadow 0.15s ease;
}

.customer-table-v2___loyalty-btn:hover {
  background-color: #1f63ea;
  box-shadow: 0 8px 16px rgba(42, 113, 255, 0.3);
}

/* .customer-table-v2___loyalty-btn:active {
  background-color: #e0ebff;
} */

/* ─────────────────────────────────────────────
   New button
───────────────────────────────────────────── */
.customer-table-v2___new-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  height: 48px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  border-radius: 1rem;
  border: none;
  background-color: #2a71ff;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 12px 24px rgba(42, 113, 255, 0.25);
  transition:
    background-color 0.15s ease,
    box-shadow 0.15s ease;
  white-space: nowrap;
}

.customer-table-v2___new-btn:hover {
  background-color: #1f63ea;
  box-shadow: 0 8px 16px rgba(42, 113, 255, 0.3);
}

.customer-table-v2___new-btn:active {
  background-color: #1a57d4;
  box-shadow: 0 4px 8px rgba(42, 113, 255, 0.2);
}

.customer-table-v2___new-btn-icon {
  display: flex;
  align-items: center;
}

/* ─────────────────────────────────────────────
   Table card section
───────────────────────────────────────────── */
.customer-table-grid___section-card {
  border-radius: 30px;
  background-color: rgba(255, 255, 255, 0.88);
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.08);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.btn-contents{
  display: flex;
  justify-content: center;
  align-items: center;
  gap:5px
}

/* ── Credit summary table specific ── */
.td-outstanding-amount-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid #fde68a;
  background-color: #fffbeb;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #92400e;
}

.td-invoice-aging-pill {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
  color: #334155;
}

/* ═══ DARK THEME — CustomerTableV2 ═══ */
.dark .customer-table-v2___header-section {
  background-color: rgba(15, 23, 42, 0.85);
  border-bottom-color: rgba(51, 65, 85, 0.7);
}
.dark .customer-table-v2___header-title { color: #f1f5f9; }

.dark .customer-table-v2___search-input {
  background-color: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .customer-table-v2___search-input::placeholder { color: #475569; }
.dark .customer-table-v2___search-input:focus {
  border-color: #2a71ff;
  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.15);
}

.dark .customer-table-v2___filter-btn {
  background-color: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.dark .customer-table-v2___filter-btn:hover {
  background-color: #334155;
  border-color: #475569;
}

.dark .customer-table-grid___section-card {
  background-color: rgba(15, 23, 42, 0.9);
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.4);
}

.dark .td-outstanding-amount-pill {
  background-color: #451a03;
  border-color: #78350f;
  color: #fbbf24;
}
.dark .td-invoice-aging-pill {
  background-color: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/CustomerTableV2.css"],"names":[],"mappings":"AAAA;;+CAE+C;AAC/C;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;+CAE+C;AAC/C;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,iDAAiD;EACjD,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;+CAE+C;AAC/C;EACE,iBAAiB,EAAE,4BAA4B;EAC/C,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;+CAE+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY,EAAE,UAAU;AAC1B;;AAEA;;+CAE+C;AAC/C;EACE,kBAAkB;EAClB,aAAa,EAAE,oCAAoC;AACrD;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,cAAc,EAAE,cAAc;AAChC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB,EAAE,gBAAgB;EACrC,yBAAyB,EAAE,cAAc;EACzC,yBAAyB;EACzB,qBAAqB,EAAE,kBAAkB;EACzC,mBAAmB;EACnB,mBAAmB,EAAE,YAAY;EACjC,cAAc,EAAE,cAAc;EAC9B,aAAa;EACb;;yBAEuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc,EAAE,cAAc;AAChC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;+CAE+C;AAC/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,eAAe;EACf;;+BAE6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB,EAAE,cAAc;EACrC,yBAAyB,EAAE,aAAa;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc,EAAE,cAAc;AAChC;;AAEA;;;+CAG+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gDAAgD;EAChD,8DAA8D;AAChE;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;;GAEG;;AAEH;;+CAE+C;AAC/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD;;yBAEuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;+CAE+C;AAC/C;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,8CAA8C;EAC9C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;AACF;;AAEA,wCAAwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;AACA,0CAA0C,cAAc,EAAE;;AAE1D;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA,uDAAuD,cAAc,EAAE;AACvE;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["/* ─────────────────────────────────────────────\n   Main container\n───────────────────────────────────────────── */\n.customer-table-v2___main-container {\n  margin-top: 70px;\n  width: 100%;\n  box-sizing: border-box;\n  margin-bottom: 70px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  padding-top: 1rem;\n  padding-bottom: 2rem;\n}\n\n/* ─────────────────────────────────────────────\n   Sticky header section\n───────────────────────────────────────────── */\n.customer-table-v2___header-section {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.7);\n  background-color: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  margin-left: -1.5rem;\n  margin-right: -1.5rem;\n  margin-top: -2rem;\n  margin-bottom: 1.5rem;\n}\n\n.customer-table-v2___header-inner {\n  max-width: 1440px;\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 80px;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  box-sizing: border-box;\n}\n\n/* ─────────────────────────────────────────────\n   Title\n───────────────────────────────────────────── */\n.customer-table-v2___header-title {\n  font-size: 1.5rem; /* 24px — matches text-2xl */\n  font-weight: 700;\n  color: #020617; /* slate-950 */\n  margin: 0;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n}\n\n/* ─────────────────────────────────────────────\n   Right-side action group\n───────────────────────────────────────────── */\n.customer-table-v2___header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem; /* gap-3 */\n}\n\n/* ─────────────────────────────────────────────\n   Search input\n───────────────────────────────────────────── */\n.customer-table-v2___search-wrap {\n  position: relative;\n  display: none; /* hidden on mobile, shown on ≥ md */\n}\n\n@media (min-width: 768px) {\n  .customer-table-v2___search-wrap {\n    display: block;\n  }\n}\n\n.customer-table-v2___search-icon {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n  color: #94a3b8; /* slate-400 */\n}\n\n.customer-table-v2___search-input {\n  height: 48px;\n  width: 320px;\n  border-radius: 1rem; /* rounded-2xl */\n  border: 1px solid #e2e8f0; /* slate-200 */\n  background-color: #ffffff;\n  padding-left: 2.75rem; /* room for icon */\n  padding-right: 1rem;\n  font-size: 0.875rem; /* text-sm */\n  color: #334155; /* slate-700 */\n  outline: none;\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease;\n  box-sizing: border-box;\n}\n\n.customer-table-v2___search-input::placeholder {\n  color: #94a3b8; /* slate-400 */\n}\n\n.customer-table-v2___search-input:focus {\n  border-color: #2a71ff;\n  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.1);\n}\n\n/* ─────────────────────────────────────────────\n   Filter button\n───────────────────────────────────────────── */\n.customer-table-v2___filter-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  height: 48px;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  border-radius: 1rem;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #475569; /* slate-600 */\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n  white-space: nowrap;\n}\n\n.customer-table-v2___filter-btn:hover {\n  border-color: #cbd5e1; /* slate-300 */\n  background-color: #f8fafc; /* slate-50 */\n}\n\n.customer-table-v2___chevron {\n  display: flex;\n  align-items: center;\n  color: #94a3b8; /* slate-400 */\n}\n\n/* ─────────────────────────────────────────────\n   Tabs row: tabs on the left, Loyalty Points\n   button anchored to the opposite (right) end\n───────────────────────────────────────────── */\n.customer-table-v2___tabs-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding-right: 1.5rem;\n}\n\n.customer-table-v2___tabs-row .tabs-container {\n  flex: 1;\n  min-width: 0;\n  width: auto;\n}\n\n.customer-table-v2___loyalty-btn {\n  flex-shrink: 0;\n  height: 48px;\n  padding-left: 1.6rem;\n  padding-right: 1.6rem;\n  border-radius: 1rem;\n  border: none;\n  background-color: #2a71ff;\n  color: #ffffff;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 12px 24px rgba(42, 113, 255, 0.25);\n  transition: background-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.customer-table-v2___loyalty-btn:hover {\n  background-color: #1f63ea;\n  box-shadow: 0 8px 16px rgba(42, 113, 255, 0.3);\n}\n\n/* .customer-table-v2___loyalty-btn:active {\n  background-color: #e0ebff;\n} */\n\n/* ─────────────────────────────────────────────\n   New button\n───────────────────────────────────────────── */\n.customer-table-v2___new-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  height: 48px;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n  border-radius: 1rem;\n  border: none;\n  background-color: #2a71ff;\n  color: #ffffff;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  box-shadow: 0 12px 24px rgba(42, 113, 255, 0.25);\n  transition:\n    background-color 0.15s ease,\n    box-shadow 0.15s ease;\n  white-space: nowrap;\n}\n\n.customer-table-v2___new-btn:hover {\n  background-color: #1f63ea;\n  box-shadow: 0 8px 16px rgba(42, 113, 255, 0.3);\n}\n\n.customer-table-v2___new-btn:active {\n  background-color: #1a57d4;\n  box-shadow: 0 4px 8px rgba(42, 113, 255, 0.2);\n}\n\n.customer-table-v2___new-btn-icon {\n  display: flex;\n  align-items: center;\n}\n\n/* ─────────────────────────────────────────────\n   Table card section\n───────────────────────────────────────────── */\n.customer-table-grid___section-card {\n  border-radius: 30px;\n  background-color: rgba(255, 255, 255, 0.88);\n  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.08);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n}\n\n.btn-contents{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap:5px\n}\n\n/* ── Credit summary table specific ── */\n.td-outstanding-amount-pill {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid #fde68a;\n  background-color: #fffbeb;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #92400e;\n}\n\n.td-invoice-aging-pill {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background-color: #f8fafc;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #334155;\n}\n\n/* ═══ DARK THEME — CustomerTableV2 ═══ */\n.dark .customer-table-v2___header-section {\n  background-color: rgba(15, 23, 42, 0.85);\n  border-bottom-color: rgba(51, 65, 85, 0.7);\n}\n.dark .customer-table-v2___header-title { color: #f1f5f9; }\n\n.dark .customer-table-v2___search-input {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .customer-table-v2___search-input::placeholder { color: #475569; }\n.dark .customer-table-v2___search-input:focus {\n  border-color: #2a71ff;\n  box-shadow: 0 0 0 4px rgba(42, 113, 255, 0.15);\n}\n\n.dark .customer-table-v2___filter-btn {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .customer-table-v2___filter-btn:hover {\n  background-color: #334155;\n  border-color: #475569;\n}\n\n.dark .customer-table-grid___section-card {\n  background-color: rgba(15, 23, 42, 0.9);\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.4);\n}\n\n.dark .td-outstanding-amount-pill {\n  background-color: #451a03;\n  border-color: #78350f;\n  color: #fbbf24;\n}\n.dark .td-invoice-aging-pill {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
